module.exports = __webpack_public_path__ + "static/media/6e063bce-ead8-43d7-9bc6-4e322be4e885.8614a7b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/6e063bce-ead8-43d7-9bc6-4e322be4e885.pdf
// module id = 2569
// module chunks = 1